module.exports = __webpack_public_path__ + "static/media/circle.cc8cafda.svg";